import React from "react";

const DefaultNavbar = () => {
  return (
    <div className="flex w-full items-center justify-center">
      <div className="mx-auto flex w-fit items-center gap-2 text-white">
        <div className="flex w-fit items-center gap-2 rounded-md bg-white/10 p-2">
          <img
            src="https://img.learntube.ai/public-assets/new%20Linkedin%20data/image%2011.png?updatedAt=1747309992449"
            loading="eager"
            alt=""
            width={24}
            height={24}
            className="h-6 w-6"
          />
          <p className="text-xs font-medium">LearnTube.ai</p>
        </div>
        <div className="h-[36px] w-[2px] bg-white/20" />
        <div className="flex flex-col items-center">
          <p className="text-[10px] text-white/50">backed by</p>
          <div className="flex items-center gap-1">
            <img
              src="https://img.learntube.ai/public-assets/post-payment-updates/use2460.svg?updatedAt=1728356838222"
              alt=""
              width={40}
              height={13}
              className="h-auto w-10"
            />
            <img
              src="https://img.learntube.ai/public-assets/post-payment-updates/text3075.svg?updatedAt=1728356926579"
              alt=""
              width={64}
              height={13}
              className="h-auto w-16"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultNavbar;
